export default <T>(v: T): T => v;
